<template>
    <div class="reception-way-tip">
        <div class="reception-way-tip__item reception-way-tip__item--left">
            <div class="reception-way-tip__title">企业主号: 企业形象对外，更适合客服场景</div>
            <div class="reception-way-tip__placeholder"></div>
            <div class="reception-way-tip__title">企业主号 (适合客服场景)</div>
            <ul class="reception-way-tip__list">
                <li><v-icon name="yes"></v-icon>会话手动转接无需客户确认</li>
                <li><v-icon name="yes"></v-icon>离线/关闭接待时客户发起会话，支持分配给其他客服</li>
                <li><v-icon name="yes"></v-icon>支持客户进入未接入池排队</li>
                <li><v-icon name="yes"></v-icon>支持自助导航</li>
            </ul>
        </div>
        <div class="reception-way-tip__item reception-way-tip__item--right">
            <div class="reception-way-tip__title">员工号: 员工形象对外，更适合销售场景</div>
            <div class="reception-way-tip__placeholder"></div>
            <div class="reception-way-tip__title">员工号 (适合销售场景)</div>
            <ul class="reception-way-tip__list">
                <li><v-icon name="no"></v-icon>会话手动转接需要客户点击名片确认</li>
                <li><v-icon name="no"></v-icon>离线/关闭接待时客户发起会话，不支持分配</li>
                <li><v-icon name="no"></v-icon>不支持排队</li>
                <li><v-icon name="no"></v-icon>不支持自助导航</li>
            </ul>
        </div>
    </div>
</template>

<script>
import { Icon } from 'vhtml-ui';

const sprites = require.context('../../assets/icons', true, /[^.]+\.svg$/);
Icon.addSprites(sprites);

export default {};
</script>

<style lang="less">
@help-font-color: #a8abb3;

.reception-way-tip {
    width: 930px;
    height: 550px;
    font-size: 14px;

    &__placeholder {
        margin: 5px 0 20px;
        width: 450px;
        height: 336px;
    }

    &__item {
        float: left;
        width: 450px;

        &--left {
            .reception-way-tip__placeholder {
                background-image: url('../../assets/roleQQ-kfuin-way.png');
            }
        }

        &--right {
            float: right;

            .reception-way-tip__placeholder {
                background-image: url('../../assets/roleQQ-staff-way.png');
            }
        }
    }

    &__title {
        line-height: 30px;
    }

    &__list {
        margin-top: 5px;
        color: @help-font-color;
        line-height: 30px;

        li {
            .v-icon {
                margin-right: 5px;
                vertical-align: -4px;
            }
        }
    }
}
</style>
